import React from 'react';
import './reportSingleValue.scss';

interface ReportSingleValueProps {
    value: string | number;
    label: string;
}

function ReportSingleValue(props: ReportSingleValueProps): JSX.Element {
    const {value, label} = props;

    return (
        <div className="c-reportSingleValue">
            <div className="c-reportSingleValue__value">{value}</div>
            <div className="c-reportSingleValue__label">{label}</div>
        </div>
    );
}
export default ReportSingleValue;
